let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Mn7y")).then(() => parcelRequire('kO7iW'));